import {
  Routes,
  UrlSegment,
  UrlMatchResult
} from '@angular/router';
import {
  companyValidSubscriptionGuard,
  jobRedirectGuard,
  applicantAuthGuard, noActiveCompanyGuard
} from './app.guards';
import { LayoutComponent } from './layout/layout.component';
import { isAuthenticated } from './auth/guards/auth.guard';



export function companyUrlMatcher(
  segments: UrlSegment[]
): UrlMatchResult | null {
  // Expect at least one segment for the company name
  if (segments.length >= 1) {
    const companyNameSegment = segments[0];
    companyNameSegment.path = companyNameSegment.path.split(/[&]/)[0];

    // Only consume the first segment
    return {
      consumed: [companyNameSegment],
      posParams: {
        companyName: companyNameSegment // Capture companyName
      }
    };
  }

  return null; // Return null if there's no match
}

export const mainRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./website/website.component')
        .then(m => m.WebsiteComponent),
    canActivate: [isAuthenticated]
  },
  {
    path: '',
    loadChildren: () => import('./website/website.routes').then(m => m.routes),
  },
  {
    path: 'aldbergen',
    loadComponent: () => import('./promo-pages/ald-bergen/components/ald-bergen.component').then(m => m.AldBergenComponent),
  },
  {
    path: 'aldoslo',
    loadComponent: () => import('./promo-pages/ald-oslo/components/ald-oslo.component').then(m => m.AldOsloComponent),
  },
  {
    path: 'aldtromso',
    loadComponent: () => import('./promo-pages/ald-tromso/components/ald-tromso.component').then(m => m.AldTromsoComponent),
  },
  {
    path: 'eurojuris',
    loadComponent: () => import('./promo-pages/eurojuris/components/eurojuris.component').then(m => m.EurojurisComponent),
  },
  {
    path: 'hotelcontinental',
    loadComponent: () => import('./promo-pages/hotelcontinental/components/hotelcontinental.component').then(m => m.HotelcontinentalComponent),
  },
  {
    path: 'kontaktdagen',
    loadComponent: () => import('./promo-pages/kontaktdagen/components/kontaktdagen.component').then(m => m.KontaktdagenComponent),
  },
  {
    path: 'bransjer',
    loadComponent: () => import('./promo-pages/industry/components/industry.component').then(m => m.IndustryComponent)
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./auth/auth.routes').then(m => m.routes),
      },
      {
        path: 'bruker',
        loadChildren: () => import('./applicant/applicant.routes').then(m => m.routes),
        canActivate: [applicantAuthGuard],
      },
      {
        path: 'kontakt',
        loadComponent: () => import('./website/pages/contact/components/contact.component').then(m => m.ContactComponent),
        canActivate: [applicantAuthGuard],
      },
      {
        path: 'stilling/:jobId',
        component: LayoutComponent,
        canActivate: [jobRedirectGuard]
      },
      {
        path: 'sok-stilling/:jobId',
        component: LayoutComponent,
        canActivate: [jobRedirectGuard, companyValidSubscriptionGuard],
        data: { isPublic: true }
      },
      {
        path: 'authorize',
        children: [
          {
            path: 'goodbye',
            loadComponent: () =>
              import('./shared/components/deleted-account/deleted-account.component')
                .then(m => m.DeletedAccountComponent),
          },
          {
            path: 'invalid',
            loadComponent: () =>
              import('./company/components/invalid-subscription/invalid-subscription.component').then(m => m.InvalidSubscriptionComponent)
          }
        ],
      },
      {
        path: '',
        loadChildren: () => import('./application/application.routes').then(m => m.routes),
      },
      {
        path: '404',
        loadComponent: () => import('./not-found/components/not-found.component').then(m => m.NotFoundComponent),
      },
      {
        path: 'company-select',
        loadComponent: () => import('./company-select/company-select.component').then(m => m.CompanySelectComponent),
        canActivate: [noActiveCompanyGuard]
      },
      {
        matcher: companyUrlMatcher,
        loadChildren: () =>
          import('./career-page/career-page.routes').then(m => m.routes)
      },
      {
        matcher: companyUrlMatcher,
        loadChildren: () => import('./company/company.routes').then(m => m.routes),
      },
      {
        path: 'integrasjon',
        loadChildren: () =>
          import('./landings/integrations.routes').then(m => m.routes)
      },
      {
        path: 'integrasjoner',
        loadChildren: () =>
          import('./landings/integrations-marketing.routes').then(m => m.routes)
      },
      {
        path: 'bransje',
        loadChildren: () =>
          import('./landings/industries.routes').then(m => m.routes)
      },
      {
        path: 'events',
        loadChildren: () =>
          import('./landings/events.routes').then(m => m.routes)
      },
      {
        path: 'om',
        loadChildren: () =>
          import('./landings/marketing.routes').then(m => m.routes)
      },
      {
        path: 'ald',
        loadChildren: () =>
          import('./promo-pages/promotion.routes').then(m => m.routes)
      },
      {
        path: '**',
        redirectTo: '404'
      }
    ],
  }
];

export const customDomainRoutes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./career-page/career-page.routes').then(m => m.routes)
      },
      {
        path: '404',
        loadComponent: () => import('./not-found/components/not-found.component').then(m => m.NotFoundComponent),
      },
      {
        path: '**',
        redirectTo: '404'
      }
    ]
  },
];
